import {post} from '@/utils/request';
import {erpserver,oaserver} from '@/utils/baseUrl';

export async function getOrderFees(params) {
    return post(erpserver+'/order/getOrderFees', params, true);
}
export async function saveOrderFee(params) {
    //return post(erpserver+'/order/saveOrderFee', params, true);
    return post(oaserver+'/oatd/saveOrderFee', params, true);
}
export async function getFeeType(params) {
    return post(erpserver+'/order/getFeeType', params, true);
}
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
export async function getkhlist(params) {
    return post(erpserver+'/currency/getkhlistWithRights', params, true);
}
export async function terminatePurchaseOrder(params) {
    return post(erpserver+'/order/terminatePurchaseOrder', params, true);
}
// 获取人
export async function getPersonList(params) {
    return post(oaserver+'/oacurrency/getPersonList', params, true);
}
// 获取部门 260121换成oaserver
export async function getGroupList(params) {
    return post(oaserver+'/oacurrency/getGroupList', params, true);
}
//化验单列表
export async function checkResult(params) {
    return post(oaserver+"/sqstore/checkResult", params, true)
};

//审批接口
export async function flowsub(params) {
    return post(oaserver+"/flow/flowSub", params, true)
};

//保存入库申请
export async function saveSqStore(params) {
    return post(oaserver+'/sqstore/saveSqStore', params, true);
}

//获取运输专员
export async function getTranUserlist(params) {
    return post(oaserver+'/tranReq/getTranUserlist', params, true);
}

//申请品种
export async function pickList(params) {
    return post(oaserver+'/sqstore/pickList', params, true)
}

//获取地址
export async function ckAddressList(params) {
    return post(oaserver+'/dipatchArrange/dict/ckAddressList', params, true)
}

//获取入库申请详情列表
export async function sqdetail(params) {
    return post(oaserver+'/sqstore/detail', params, true)
    //return applicdetail
}

//获取入库申请订单列表
export async function sqlist(params) {
    return post(oaserver+'/sqstore/list', params, true)
    //return appliclist
}

//订单列表
export async function getPurchaseOrderList(params) {
    return post(erpserver+'/order/getPurchaseOrderList', params, true)
    //return json1
}
//订单详情
export async function getPurchaseOrderDetail(params) {
    return post(erpserver+'/order/getPurchaseOrderDetail', params, true)
    //return detaildata
}
//保存订单
export async function saveOrder(params) {
    return post(erpserver+'/order/saveOrder', params, true)
}
//获取合同品种
export async function getPzListByHtid(params) {
    return post(erpserver+'/order/getPzListByHtid', params, true)
}
//获取合同列表
export async function getHtList(params) {
    return post(erpserver+'/order/getHtList', params, true)
    //return  htdata
}
//开证商列表[公共接口]
export async function getLssuerList(params) {
    return post(erpserver+'/customer/getLssuerList', params, true)
}
//返回港口[有公共接口]
export async function getPortList(params) {
    return post(erpserver+'/currency/getPortList', params, true)
}

//获取仓库列表
export async function getWarehouseList(params) {
    return post(oaserver+'/oacurrency/getWarehouseList', params, true);
}
//收货地址
export async function getAddressList(params) {
    return post(oaserver+'/oacrm/getAddressList', params, true);
}
//定向
export async function getCompanyList(params) {
    return post(oaserver+"/oacurrency/getCompanyList", params, true)
};

//获取挂牌价
export async function getRelPurchasePrice(params) {
    return post(erpserver+'/getRelPurchasePrice', params, true)
}
